module.exports = __webpack_public_path__ + "static/media/dont1.98df6561.png";